<template>
  <div class="tw-flex tw-h-full tw-flex-col">
    <template v-if="docs.length > 0">
      <SfBannerInline
        v-if="pending || failed"
        variant="warning"
        :title="bannerTitle"
        class="tw-mb-2"
      />
      <div class="tw-min-h-0 tw-flex-1">
        <PDFTron
          class="tw-h-full"
          :initial-docs="docs"
          :path="pdftronPath"
          :owner-id="ownerId"
          :owner-type="ownerType"
          :enable-annotations="enableAnnotations"
          :enable-annotations-toolbar="enableAnnotationsToolbar"
          :enable-ai-proposal-drawer="enableAiProposalDrawer"
        />
      </div>
    </template>
    <div
      v-else
      class="tw-flex tw-h-full tw-items-center tw-justify-center tw-p-6"
    >
      <SfLoadingDots v-if="loading" data-testid="document-preview-loading" />
      <SfBannerInline
        v-else-if="pending"
        variant="info"
        :title="I18n.t('documents.preview.pending')"
        class="tw-max-w-md"
      />
      <SfBannerInline
        v-else
        variant="danger"
        :title="I18n.t('documents.preview.load_error')"
        class="tw-max-w-md"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import PDFTron from './pdftron.vue'
import SfBannerInline from '@app/shared/vue/components/sf-banner/sf-banner-inline.vue'
import SfLoadingDots from '@app/shared/vue/components/loaders/sf-loading-dots.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { useDocumentPreviewParts } from '@app/shared/document-preview/parts/use-document-preview-parts'
import type { PreviewEntry } from '@app/shared/document-preview/parts/types'

interface Props {
  previews: PreviewEntry[]
  pdftronPath: string
  ownerId: number | string
  ownerType: string
  enableAnnotations?: boolean
  enableAnnotationsToolbar?: boolean
  enableAiProposalDrawer?: boolean
}

const {
  previews,
  pdftronPath,
  ownerId,
  ownerType,
  enableAnnotations = false,
  enableAnnotationsToolbar = false,
  enableAiProposalDrawer = false,
} = defineProps<Props>()

const I18n = useI18n()

const { docs, loading, pending, failed } = useDocumentPreviewParts(previews)

const bannerTitle = computed(() =>
  pending.value
    ? I18n.t('documents.preview.some_pending')
    : I18n.t('documents.preview.some_failed')
)
</script>
